/** DOM id of a rendered section, used to scroll to it. */
export const anchorDomId = (sectionId: string): string => `pb-${sectionId}`;
